'use strict';

/*global Container */
/*global Cookies */
/*global Translator */
/*global Configurations*/
/*global K2Modal */
/*global K2Confirm */
/*global Router*/
/*global Notifications*/
/*global K2Keyboard*/
/*global K2KeyboardFormController*/
/*global K2FormationViewer*/
/*global K2ImageViewer*/
/*global LogoutAlert*/
/*global K2LoginKeyboard*/
/*global K2Location*/
/*global BarcodeService*/
/*global ArticleService*/
/*global LocationService*/
/*global SectorService*/
/*global HandlingUnitService*/
/*global WarehouseService*/
/*global PackingPlaceService*/
/*global TransferNoteService*/
/*global DeliveryNoteService*/
/*global PickingService*/
/*global CompletionService*/
/*global PrintingService*/
/*global ReceiptService*/
/*global InputService*/
/*global SelectService*/
/*global OutputService*/
/*global ConfirmService*/
/*global CommonProcessService*/
/*global OptimizationService*/
/*global ConsolidationService*/
/*global ItemForm*/
/*global ItemMismatchProcessingForm*/
/*global K2PrinterSetting*/
/*global UnholdDocument*/
/*global UnfinishedDocuments*/
/*global Info*/
/*global ProductInfo*/
/*global InternetConnectionManager*/
/*global K2AboutApp*/

/*exported services*/
var services = new Container();

$(document).ready(function () {
  services.set('translator', new Translator('k2_translations'));
  services.set('cookies', new Cookies());
  services.set('configurations', new Configurations('k2_configurations'));

  services.set('item-form-confirm', new K2Confirm('k2-item-form-confirm')); //potrebuji jako prvni, protoze oteviram dalsi modaly nad
  services.set('modal', new K2Modal('k2-modal'));
  services.set('modal-lookup', new K2Modal('k2-modal-lookup'));
  services.set('modal-location', new K2Modal('k2-modal-location'));
  services.set('modal-handling-unit', new K2Modal('k2-modal-handling-unit'));
  services.set('modal-consolidation', new K2Modal('k2-modal-consolidation'));
  services.set('modal-input', new K2Modal('k2-modal-input'));
  services.set('modal-select', new K2Modal('k2-modal-select'));
  services.set('modal-output', new K2Modal('k2-modal-output'));
  services.set('modal-keyboard', new K2Modal('k2-modal-keyboard'));
  services.set('modal-image', new K2Modal('k2-modal-image'));
  services.set('modal-notifications', new K2Modal('k2-modal-notifications'));

  services.set('confirm', new K2Confirm('k2-confirm'));
  services.set('confirm-second', new K2Confirm('k2-confirm-second'));

  services.set('router', new Router('k2_paths'));
  services.set('notifications', new Notifications());

  services.set('keyboard', new K2Keyboard());
  services.set('keyboard-form-controller', new K2KeyboardFormController());

  services.set('about-app', new K2AboutApp());

  services.set('internet-connection-manager', new InternetConnectionManager());
  services.set('formation-viewer', new K2FormationViewer());
  services.set('image-viewer', new K2ImageViewer(services.get('modal-image')));
  services.set('location', new K2Location());
  services.set('logout-alert', new LogoutAlert());
  services.set('login-keyboard', new K2LoginKeyboard());
  services.set('barcode-service', new BarcodeService());
  services.set('article-service', new ArticleService());
  services.set('location-service', new LocationService());
  services.set('sector-service', new SectorService());
  services.set('handling-unit-service', new HandlingUnitService());
  services.set('warehouse-service', new WarehouseService());
  services.set('packing-place-service', new PackingPlaceService());
  services.set('transfer-note-service', new TransferNoteService());
  services.set('delivery-note-service', new DeliveryNoteService());
  services.set('picking-service', new PickingService());
  services.set('receipt-service', new ReceiptService());
  services.set('printing-service', new PrintingService());
  services.set('completion-service', new CompletionService());
  services.set('consolidation-service', new ConsolidationService());
  services.set('input-service', new InputService());
  services.set('select-service', new SelectService());
  services.set('output-service', new OutputService());
  services.set('confirm-service', new ConfirmService());
  services.set('common-process-service', new CommonProcessService());
  services.set('optimization-service', new OptimizationService());
  services.set('item-form', new ItemForm());
  services.set('item-mismatch-processing-form', new ItemMismatchProcessingForm());
  services.set('printer-setting', new K2PrinterSetting());
  services.set('unhold-document', new UnholdDocument());
  services.set('unfinished-documents', new UnfinishedDocuments());
  services.set('info', new Info());
  services.set('product-info', new ProductInfo());

  //services.set('main-page-module', ...); //hlavni modul stranky, ktery lze volat napriklad z K2Location ... nutne dle potreby nastavit
});
